const CommunicationMethodEnum = {
  SMS: { value: 'S', name: 'Text Message' },
  PHONE: { value: 'P', name: 'Phone Call' },
};

export default CommunicationMethodEnum;
